import { useEffect, useRef } from 'react';
import {
  clearRecapReadyNotice,
  selectRecapReadyNotice,
} from 'redux/slices/callsSlice.slice';
import { useAppDispatch, useAppSelector } from 'redux/storeHooks';
import { useToast } from '../../../app/ReusableToast';

/**
 * Shows and consumes GUIDE-S recap-ready websocket notices globally.
 *
 * Side effects: opens the shared success toast and clears the transient Redux
 * notice after each newly received event.
 *
 * @returns No visible element; the shared toast provider renders the notice.
 */
export function GuidesRecapReadyToast() {
  const dispatch = useAppDispatch();
  const notice = useAppSelector(selectRecapReadyNotice);
  const lastNoticeRef = useRef<typeof notice>(null);
  const toast = useToast();

  useEffect(() => {
    if (!notice || lastNoticeRef.current === notice) {
      return;
    }

    lastNoticeRef.current = notice;
    toast('Your post-call recap is ready.', 'success');
    dispatch(clearRecapReadyNotice());
  }, [dispatch, notice, toast]);

  return null;
}
